import styled from "styled-components"

const StyledSmallTitle = styled.p`
  color: #c39779;
  font-size: 10px;
  line-height: 10px;
  letter-spacing: 2px;
  margin-bottom: 8px;
  text-transform: uppercase;
  font-family: "Made Bold", sans-serif;
  @media (min-width: 768px) {
    font-size: 13px;
    line-height: 13px;
    letter-spacing: 3px;
    margin-bottom: 12px;
  }
`

export default StyledSmallTitle
